import { render, staticRenderFns } from "./ProductLicenseExpiration.vue?vue&type=template&id=9feb3e36&scoped=true&"
import script from "./ProductLicenseExpiration.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feb3e36",
  null
  
)

export default component.exports